import { Inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import angular from 'angular'
import { BootstrapData } from 'elements-sdk/src'

import { BOOTSTRAP_DATA } from 'api/providers'

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  value: string|null = null
  prefix: string|null = null

  constructor (
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
    private title: Title,
  ) { }

  set (title: string, $scope?: angular.IScope): void {
    const refresh = () => {
      if ($scope) {
        this.value = $scope.$eval(title)
      } else {
        this.value = title
      }
      if (this.value) {
        const prefix = this.prefix ? `${this.prefix} |` : ''
        this.title.setTitle(`${prefix}${this.value} | ${this.bootstrapData.systemName}`)
      }
    }

    $scope?.$watch(title, refresh)

    refresh()
  }

  setPrefix (prefix: string|null): void {
    this.prefix = prefix
    if (this.value) {
      this.set(this.value)
    }
  }
}
